<template>
    <div class="product">
        <div class="headTitle">
            <div class="shadowTxt">5L PRODUCT</div>
            <div class="title">5L产品创新体系</div>
            <div class="text">
                以地产开发、商业运营、物业服务为核心业务，实现多元化业务经营。创领绿色智慧城市新模式，探索地产运营新品类，营造多彩生活新体系，这是爱情地产对品牌的创新，更是对未来生活的革新。<br>
                L是love，更有爱，贴心的服务理念；是light，更轻盈的生活方式；是life，更全维度的健康生活体系。
            </div>
            <div class="bg"></div>
        </div>
        <div class="main">
            <div class="LPart" v-for="(item,idx) in lpart" :key="idx">
                <div class="LTitle">
                    <div class="sTitle"><span>L</span>{{item.sTitle1}}</div>
                    <div class="bTitle">{{item.bTitle}}</div>
                    <div class="txt">
                        <p>{{item.sTitle.slice(0,6)}}</p>
                        <p>{{item.sTitle.slice(6)}}</p>
                    </div>
                </div>
                <div class="LCont">
                    <p v-for="(subItem,subIndex) in item.Ltext" :key="subIndex">{{subItem}}</p>
                </div>
            </div>
        </div>
        <div class="Ingenuity">
            <div class="zyh"><img src="../../assets/images/zyh.png" alt=""></div>
            <div class="oTitle">{{ingen.title}}</div>
            <div class="ingenImg"><img src="../../assets/images/inge.png" alt=""></div>
            <div class="cont">{{ingen.content}}</div>
            <div class="common">
                <div class="part" v-for="(item,index) in masterList" :key='index'>
                    <div class="img"><img :src="item.icon" alt=""></div>
                    <div class="txt">{{item.name}}</div>
                </div>
            </div>
        </div>
        <div class="technology">
            <div class="oTitle">{{science.title}}</div>
            <div class="cont">{{science.content}}</div>
            <div class="bgImg">
                <div class="item">
                    <div class="circle" v-for="(item,index) in sells.slice(0,4)" :key="index">{{item.name}}</div>
                </div>
                <div class="item2">
                    <div class="circle" v-for="(item,index) in sells.slice(4)" :key="index">{{item.name}}</div>
                </div>
            </div>
        </div>
        <div class="company">
            <div class="oTitle">{{love.title}}</div>
            <div class="cont">{{love.content}}</div>
            <div class="imgPart">
                <div class="imgItem" v-for="(item,idx) in cards" :key="idx">
                    <div class="img"><img :src="item.img" alt=""></div>
                    <div class="title">{{item.name}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { PRODUCT_LPART,PRODUCT_CARD_LIST,PRODUCT_MASTER_LIST,COMPANY_LOVE ,COMPANY_SCIENCE,COMPANY_INGEN,PRODUCT_SELLS} from '../../data/product'

export default {
    metaInfo: {
        title: '产品创新-爱情地产',
        meta: [{
        name: 'keyWords',
        content: '爱情地产'
        },
        {
        name: 'description',
        content: ''
        }]
    },
    data(){
        return{
            lpart:PRODUCT_LPART,
            cards:PRODUCT_CARD_LIST,
            masterList: PRODUCT_MASTER_LIST,
            love:COMPANY_LOVE,
            science:COMPANY_SCIENCE,
            ingen:COMPANY_INGEN,
            sells:PRODUCT_SELLS
        }
    }
}
</script>

<style scoped lang='less'>
*{
    margin: 0;
    padding: 0;
}
img{
    width: 100%;
}
.headTitle {
  padding: 20px 0 7px 0;
  background: #fff;
  
  .shadowTxt {
    font-size: 40px;
    line-height: 47px;
    color: #f8f8f8;
    font-family: "DIN Alternate Bold";
    font-weight: bold;
    padding: 0 15px;
  }
  .title {
    color: #222;
    font-size: 18px;
    line-height: 25px;
    font-family: "苹方-简 中黑体";
    font-weight: 600;
    margin-top: -28px;
    padding: 0 15px;
  }
  .text {
    color: #666666;
    font-size: 13px;
    line-height: 20px;
    font-family: "苹方-简 常规体";
    margin-top: 9px;
    padding: 0 15px;
  }
  .bg{
      height: 143px;
      background: url('../../assets/images/bg3.png') no-repeat;
      background-size: 100% 100%;
      margin-top: -80px;
  }
}
.main{
    margin: -40px 15px 20px;
    box-shadow: 0 6px 10px #E8E8E8;
    // padding: 0 15px;
    background: #fff;
    border-radius: 5px;
    .LPart{
        display: flex;
        align-items: center;
        // justify-content: space-around;
        padding: 18px 0px 21px 0;
        margin: 0 19px;
        border-bottom: 1px solid #EFEFEF;
        .LTitle{
            // padding-right: 25px;
            // padding: 0 25px 0 27px;
            width: 119px;
            text-align: center;
            box-sizing: border-box;
            font-size: 10px;
            line-height: 14px;
            border-right: 1px solid #E8E8E8;
            .sTitle{
                color: #CCCCCC;
                font-size: 10px;
                line-height: 14px;
                span{
                    color: #E95506;
                    font-size: 14px;
                    line-height: 20px;
                }
            }
            .bTitle{
                color: #000;
                font-size: 14px;
                line-height: 20px;
                margin-top: 4px;
                font-weight: 600;
            }
            .txt{
                
                color: #999999;
                font-size: 10px;
                line-height: 14px;
                margin: 5px auto 0;
                p{
                    line-height: 16px;
                }
            }
        }
        .LCont{
            flex: 1;
            color: #333333;
            font-size: 12px;
            line-height: 20px;
            padding-left: 17px;
            
        }
    }
}
.oTitle{
    color: #E95506;
    font-size: 15px;
    line-height: 21px;
    font-weight:600;
}
.cont{
    color: #666;
    font-size: 13px;
    line-height: 20px;
    margin-top: 10px;
}
.Ingenuity{
    padding: 0 15px 21px;
    .zyh{
        width: 42px;
        height: 32.15px;
        margin-bottom: -19px;
        img{
            display: flex;
        }
    }
    .ingenImg{
        margin-top: 5px;
    }
    .cont{
        color: #666;
        font-size: 13px;
        line-height: 20px;
        margin-top: 10px;
    }
    .common{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 10px;
        .part{
            width: 108px;
            background: url('../../assets/images/xbg1.png') no-repeat;
            background-size: 100% 100%;
            padding: 7px 0px 16px 6px;
            box-shadow: 4px 6px 10px #efefef;
            // border: 1px dotted rgb(150, 150, 150);
            &:nth-child(2){
                background: url('../../assets/images/xbg2.png') no-repeat top left;
                background-size: 100% 100%;
            }
            &:nth-child(3){
                background: url('../../assets/images/xbg3.png') no-repeat top left;
                background-size: 100% 100%;
            }
            .img{
                width: 16px;
                height: 16px;
                // border: 1px dotted rgb(150, 150, 150);
                // margin-top: 7px;
                // margin-left: 6px;
                img{
                    display: flex;
                }
            }
            .txt{
                color: #333;
                font-size: 13px;
                line-height: 18px;
                margin-top: 5px;
                margin-left: 6px;
            }
        }
    }
}
.technology{
    padding: 15px 15px 20px;
    background: url('../../assets/images/line.png') no-repeat;
    background-size: 100% 100%;
    .cont{
        margin-bottom: 5px;
    }
    .bgImg{
        background: url('../../assets/images/bg4.png') no-repeat;
        background-size: 100% 100%;
        padding: 43px 10px;
        box-sizing: border-box;
        .item{
            padding: 0 20px 0 40px;
            overflow: hidden;
            margin-bottom: 20px;
        }
        .circle{
            width: 50px;
            height: 50px;
            background: url('../../assets/images/ball.png') no-repeat;
            background-size: 100% 100%;
            color: #fff;
            font-size: 12px;
            line-height: 50px;
            text-align: center;
            margin-right: 21px;
            float: left;
            // border: 1px dotted #ccc;
            box-sizing: border-box;
            &:last-child{
                margin-right: 0;
            }
        }
        .item2{
            padding: 0 10px;
            overflow: hidden;
            .circle{
                margin-right: 13px;
                &:last-child{
                    margin-right: 0;
                }
            }
        }
        
    }
}
.company{
    padding: 20px 15px 30px;
    .imgPart{
        overflow: hidden;
        margin-top: 10px;
        .imgItem{
            position: relative;
            float: left;
            margin: 0 5px 5px 0;
            &:nth-child(2n){
                margin-right: 0;
            }
            .img{
                width: 170px;
                height: 96px;
               
            }
            .title{
                font-size: 14px;
                line-height: 20px;
                position: absolute;
                left: 10px;
                bottom: 5px;
                color: #fff;
            }
        }
    }
}
</style>